import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { LinksProps } from "@thrivetribe/mvf.ui.organisms.footer";
import { AuthContext } from "components/auth";
import { playerSidebarLinks, staffSidebarLinks } from "configs/UrlConfig";

interface SidebarLinksProps {
  isSidebarOpen: boolean;
  setIsSitebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SidebarLinks: React.FC<SidebarLinksProps> = ({ isSidebarOpen, setIsSitebarOpen }) => {
    let isStaff = useContext(AuthContext)?.isStaff
    let links = isStaff ? staffSidebarLinks : playerSidebarLinks;
    
  return (
    <div className="sidebar__top-links">
      {links?.map((link, index) => (
        <NavLink
          key={index}
          onClick={() => setIsSitebarOpen(!isSidebarOpen)}
          className={({ isActive }) =>
            classnames("sidebar__item", {
              "sidebar__item--active": isActive,
            })
          }
          to={link.url}
          end={link.end ?? false}
        >
          {link.text}
        </NavLink>
      ))}
    </div>
  );
};
